import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { __read, __spreadArrays } from 'tslib';

import { Hotel } from 'src/app/model';
import { HotelService, Util } from 'src/app/services';

@Component({
    selector: 'app-hotel-reserva',
    templateUrl: './hotel-reserva.component.html',
    styleUrls: ['./hotel-reserva.component.scss'], standalone: false
})
export class HotelReservaComponent implements OnInit {
    constructor(
        private hotelService: HotelService,
        private utilService: Util
    ) { }
    @Input() idadeInvalida: boolean = false;
    @Output() alterou = new EventEmitter<any>();
    @Output() fechou = new EventEmitter<any>();
    @Output() verificaIdadeValida: EventEmitter<void> = new EventEmitter<void>();
    @Input() hotel: Hotel;
    @Input() politicaListagem: {agenciaId: number, hotelId: number, quartoId: number, guid: string,listagem: boolean} = { agenciaId: 0, hotelId: 0, quartoId: 0, guid: "", listagem: false };

    carregando = false;
    politica: any;
    mensagensErro: any[];
    mensagemSucesso: string;

    ngOnInit() {
        this.buscarPolitica();
    }

    buscarPolitica() {
        this.carregando = true;

        let buscarPolitica = this.hotelService.buscarPolitica(this.hotel);

        if (this.politicaListagem.listagem)
            buscarPolitica = this.hotelService.buscarPoliticaListagem(this.politicaListagem.hotelId, this.politicaListagem.quartoId, this.politicaListagem.agenciaId, this.politicaListagem.guid);

        buscarPolitica.subscribe(
            dados => {
                this.politica = dados;
                if (!this.politicaListagem.listagem) {
                    this.hotel = this.politica.Hotel;
                    this.alterou.emit(this.hotel);
                }
                this.carregando = false;
            }, erro => {
                this.carregando = false;
                console.log(erro);
                this.mensagensErro = this.errorHandler(erro);
                if (this.politicaListagem.listagem) {
                   this.mensagensErro.push('Não foi possível buscar a política de listagem do hotel, tente novamente mais tarde! Esse erro não invalida o Hotel ou o Quarto');
                }
            });
    }

    reservar() {

        if (this.idadeInvalida) {
            this.mensagensErro = [];
            this.mensagensErro.push(this.utilService.fazerTraducao('Verifique a Idade dos passageiros.'));
            return;
        }

        const confirmar = window.confirm(
            `Aceite de Termos e Condições\n\nAo prosseguir, você confirma que revisou todas as informações da sua reserva, incluindo a política do hotel, o número de hóspedes, a configuração dos quartos, a localização e o nome do hotel.\n\nAo clicar em "OK", você declara que está ciente e de acordo com os termos e condições aplicáveis, e que as informações fornecidas estão corretas. Se houver necessidade de correções, faça as alterações antes de concluir sua reserva.`
        );

        if (confirmar) {
            this.carregando = true;
            this.politica.Politica.Observacoes = this.hotel.Observacao;
            this.hotelService.reservarHotel(this.politica.Politica).subscribe(
                dados => {

                    this.hotel = dados.Hotel;
                    this.carregando = false;
                    if (this.hotel.Status === 3 || this.hotel.Status === 4) {
                        this.mensagemSucesso = `Hotel ${this.hotel.Nome} reservado com sucesso`;
                    } else if (this.hotel.Status === 1) {
                        this.mensagemSucesso = `Hotel ${this.hotel.Nome} aguardando retorno do fornecedor`;
                    } else if (this.hotel.Status === 7) {
                        this.mensagemSucesso = `A reserva do hotel ${this.hotel.Nome} tem problemas técnicos, entre em contato com seu consultor`;
                    } else {
                        this.mensagemSucesso = `Entre em contato com seu consultor, houve algum problema não identificado nesta reserva!`;
                    }

                    this.alterou.emit(this.hotel);

                }, erro => {
                    this.carregando = false;
                    console.log(erro);
                    this.mensagensErro = this.errorHandler(erro);
                    this.alterou.emit(this.hotel);
                });
        }
    }


    public errorHandler(erro): string[] {

        let mensagem = [];
        switch (erro.status) {
            case 0: mensagem.push('o servidor não respondeu, tente novamente mais tarde!'); break;
            case 400: mensagem.push('Houve algum erro na execução, tente novamente!'); break;
            case 401: mensagem.push('você não tem autorização para executar esta ação!'); break;
            case 404: mensagem.push('Solicitação inválida!'); break;
            case 406: mensagem.push(erro.error.mensagem); break;
            // case 500: mensagem.push('Houve um erro interno no servidor! tente novamente, caso o erro persista, entre em contato com o suporte' ); break;
            case 500: mensagem.push(erro.error.ExceptionMessage); break;
            default: mensagem.push(erro.statusText);
        }
        if (erro.error != null && erro.error.mensagens != null) {
            mensagem = __spreadArrays([mensagem], __read(erro.error.mensagens));
        }
        return mensagem;

    }

    QuartosComPrePagamento(hotel) {
        return hotel.Quartos.some(x => x.ExigePrePagamento);
    }

}
